import { z } from "zod";
/** Uniform error envelope returned by the API for every non-2xx response. */
export const apiErrorSchema = z.object({
    error: z.object({
        code: z.string(),
        message: z.string(),
        /** Field-level messages, keyed by dotted path, for form validation. */
        fields: z.record(z.string(), z.array(z.string())).optional(),
    }),
});
export const API_ERROR_CODES = [
    "BAD_REQUEST",
    "UNAUTHORIZED",
    "FORBIDDEN",
    "NOT_FOUND",
    "CONFLICT",
    "VALIDATION",
    "RATE_LIMITED",
    "UPSTREAM_UNAVAILABLE",
    "AGE_VERIFICATION_REQUIRED",
    "INVALID_CODE",
    "PASSWORD_REQUIRED",
    "INTERNAL",
];
//# sourceMappingURL=http.js.map